import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "regenerator-runtime/runtime.js";
import Nl2br from 'vue-nl2br';
var NotificationsLinkedTabs = function NotificationsLinkedTabs() {
  return import('@/components/organisms/NotificationsLinkedTabs');
};
var PageHeader = function PageHeader() {
  return import('@/components/molecules/PageHeader');
};
var ExternalLink = function ExternalLink() {
  return import('@/components/atoms/ExternalLink');
};
export default {
  components: {
    Nl2br: Nl2br,
    NotificationsLinkedTabs: NotificationsLinkedTabs,
    PageHeader: PageHeader,
    ExternalLink: ExternalLink
  },
  computed: {
    announcement: function announcement() {
      return useAnnouncementStore().getAnnouncements;
    },
    readAt: function readAt() {
      return useAnnouncementStore().getReadAt;
    },
    messagesUnreadCount: function messagesUnreadCount() {
      return useMessageStore().getUnreadCount;
    }
  },
  beforeMount: function beforeMount() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return useAnnouncementStore().fetchAnnouncements();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getBody: function getBody(item) {
      return this.$i18n.locale === 'ja' ? item.ja : item.en;
    },
    getIsUnread: function getIsUnread(item) {
      return item.at > this.readAt;
    },
    getLinkUrl: function getLinkUrl(link) {
      return link.includes('http') ? link : "/".concat(link);
    },
    getLinkTarget: function getLinkTarget(link) {
      return link.includes('http') ? '_blank' : '_self';
    }
  }
};